/*eslint-disable */
module.exports = $translateProvider => {
  $translateProvider.registerAvailableLanguageKeys(['en', 'es', 'pt'], {
    'en_*': 'en',
    'es_*': 'es',
    'pt_*': 'pt',
  });

  $translateProvider.fallbackLanguage('es');
  $translateProvider.usePostCompiling(true);
  // @source: https://angular-translate.github.io/docs/#/guide/19_security
  $translateProvider.useSanitizeValueStrategy('escaped');

  $translateProvider.useStaticFilesLoader({
    prefix: 'locale/',
    suffix: '.json'
  });

  $translateProvider.preferredLanguage('es');
};
